import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InviteJobApplicationStorageService {
  private keyStorage: string = 'hashInviteJobApplication';

  sessionStorage = sessionStorage;

  getInvite(): string | null {
    return this.sessionStorage.getItem(this.keyStorage);
  }

  setInvite(hashInvite: string): void {
    this.sessionStorage.setItem(this.keyStorage, hashInvite);
  }

  removeInvite(): void {
    this.sessionStorage.removeItem(this.keyStorage);
  }
}
